import { io } from 'socket.io-client';

export const mobiTalkSocket = io(
  import.meta.env.VITE_WEB_SOCKET_HOST + '/customer-chat',
  {
    transports: ['websocket'],
    withCredentials: true,
    autoConnect: true,
  },
);
